import { BASE_DOMAIN } from 'src/config';

export function getSubDomain(): string | null {
  const hostname = window.location.hostname;
  return hostname === BASE_DOMAIN ? null : hostname.replace(`${BASE_DOMAIN}`, '');
}
